<div class="booking-card">
  <mat-card class="curtains">
    <div class="booking-header secondary-icon">
      <h5>Booking on-site inspection</h5>
      <div class="booking-kebab-panel">
        <button matIconButton (click)="confirmDeleteBooking()">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
    <mat-card-content>
      <form [formGroup]="bookingForm">
        <div class="card-body">
          <mat-form-field>
            <mat-label>Booking Options</mat-label>
            <mat-select
              formControlName="bookingOption"
              (selectionChange)="updateJob('bookingOption')"
              required
              [disabled]="!job.inspectionDate">
              @if (!onSite) {
                <mat-option value="PROPOSE_ON_SITE_INSPECTION">Propose on-site inspection </mat-option>
              }
              @if (onSite) {
                <mat-option value="PROPOSE_NEW_DATE">Propose new date</mat-option>
              }
              @if (onSite && job.inspectionDate && !hasQuote && !inspectionDateInPast) {
                <mat-option value="CANCELLED_DUE_TO_NO_SHOW">Cancelled due to no show </mat-option>
              }
            </mat-select>
            <mat-error>Booking option is <strong>required</strong></mat-error>
          </mat-form-field>
          @if (bookingOption.value === 'CANCELLED_DUE_TO_NO_SHOW') {
            <div class="cancel-booking-message subtitle-2">The insurance company will follow-up on this claim.</div>
          }
          @if (bookingOption.value !== 'CANCELLED_DUE_TO_NO_SHOW') {
            <mat-form-field class="medium-field primary-icon">
              <mat-label>Proposed Date</mat-label>
              <input
                (keypress)="dateInputHelper.restrictDateInput($event)"
                [matDatepicker]="inspectionDatepicker"
                [min]="minDate"
                [matDatepickerFilter]="availableDatesFilter"
                formControlName="proposedDate"
                matInput />
              <mat-datepicker-toggle [for]="inspectionDatepicker" matSuffix></mat-datepicker-toggle>
              <mat-datepicker #inspectionDatepicker></mat-datepicker>
              <mat-hint>Date format DD/MM/YYYY</mat-hint>
              @if (proposedDate.hasError('required') && !proposedDate.hasError('matDatepickerParse')) {
                <mat-error> Proposed date is <strong>required</strong> </mat-error>
              }
              @if (
                proposedDate.hasError('matDatepickerFilter') &&
                !proposedDate.hasError('matDatepickerParse') &&
                !proposedDate.hasError('required')
              ) {
                <mat-error> Proposed date is not available </mat-error>
              }
              @if (
                proposedDate.hasError('matDatepickerMin') &&
                !proposedDate.hasError('matDatepickerFilter') &&
                !proposedDate.hasError('matDatepickerParse') &&
                !proposedDate.hasError('required')
              ) {
                <mat-error> Proposed date is in the past </mat-error>
              }
              @if (proposedDate.hasError('matDatepickerParse')) {
                <mat-error> The date format is <strong>DD/MM/YYYY</strong> </mat-error>
              }
            </mat-form-field>
          }
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
